export default function ArrowsLeftRight(
	props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path d="M2.94531 16H29.0564" stroke="currentColor" strokeWidth="1.5" strokeMiterlimit="10" />
			<path
				d="M10.7786 8.16675L2.94531 16.0001L10.7786 23.8334"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
			<path
				d="M21.2188 23.8334L29.0521 16.0001L21.2188 8.16675"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeMiterlimit="10"
			/>
		</svg>
	)
}
